import { render, staticRenderFns } from "./BriqCheckButtons.vue?vue&type=template&id=74d16749&scoped=true&lang=pug&"
import script from "./BriqCheckButtons.vue?vue&type=script&lang=js&"
export * from "./BriqCheckButtons.vue?vue&type=script&lang=js&"
import style0 from "./BriqCheckButtons.vue?vue&type=style&index=0&id=74d16749&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d16749",
  null
  
)

export default component.exports